export default "__VITE_PUBLIC_ASSET__ad7407a8__"